import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@mui/material';
import GavelIcon from '@mui/icons-material/Gavel';
import { useTheme } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';
import { externalLink } from 'utils/helpers/helper';
import { getItemInStorage } from 'utils/functions';

/**
 * Botón "Ir al remate". Si hay un remate en vivo parpadea; abre el enlace
 * externo del rol o, sin sesión, redirige a login.
 */
function GoToLiveButton({ hasUser, islive, liveName, externalRolLink }) {
  const theme = useTheme();
  const history = useHistory();

  const handleClick = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    if (hasUser) {
      return window.open(externalLink(getItemInStorage('user'), externalRolLink));
    }
    return history.push('/login');
  };

  return (
    <Button
      component="a"
      fullWidth
      color={!islive ? 'primary' : 'inherit'}
      startIcon={<GavelIcon style={{ color: islive ? theme.palette.error.main : undefined }} />}
      onClick={handleClick}
      variant="contained"
      href={externalLink(getItemInStorage('user'), externalRolLink)}
      target="_blank"
      sx={{
        fontWeight: 700,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
        ...(islive && {
          animation: 'sidebar-blink 1.5s linear infinite',
          '@keyframes sidebar-blink': {
            from: { opacity: 1 },
            to: { opacity: 0.4 },
          },
        }),
      }}>
      Ir {liveName}
    </Button>
  );
}

GoToLiveButton.propTypes = {
  hasUser: PropTypes.bool,
  islive: PropTypes.bool,
  liveName: PropTypes.string,
  externalRolLink: PropTypes.string,
};

export default GoToLiveButton;
